export const staticImageSources = {
  '/assets/images/app_logo.png': 'app-logo',
  '/assets/images/no_image.png': 'fallback',
};

export const deviceSizes = [640, 750, 828, 1080, 1200, 1920, 2048, 3840];
export const imageSizes = [16, 32, 48, 64, 96, 128, 256, 384];
export const imageQualities = [75, 85, 100];
